import { MultiSelect } from "./multiSelect.js";
import { ModalEditAbsence } from './modals/modalEditAbsence.js';

export class AbsentPupilSelect extends MultiSelect {
    constructor(settings, classRegisterData) {
        settings.addData = true;
        settings.listTitle = "Schüler wählen",
        super(settings);
        this.classRegisterData = classRegisterData;

    }
  
    renderItem(item) {

        if (item.info === undefined) item.info = { justified: false, value: this.classRegisterData.hourSpan };
        if (item.info.value === undefined) item.info.value = this.classRegisterData.hourSpan;
        /*
        let elSelected = HTMLElement.createFromHTML(
           `<div class="absent-pupil-select selected-item">
               <div class="left">
                  <input class="justified" type="checkbox"></input>
                </div>
                <div class="middle">
                   <div class="name"></div>
                   <div class="cnt-hours"></div>
                   <div class="note"></div>
                </div>
                <div class="btn-delete"><div class="font-icon icon-cross"></div></div>
            </div>`
        );
        */

        let elSelected = HTMLElement.createFromHTML(
            `<div class="absent-pupil-select selected-item">
                <div class="left">
                   <label class="cbx-container">
                      <input class="justified" type="checkbox"></input>
                      <span class="checkmark">
                    </label>
                 </div>
                 <div class="middle">
                    <div class="name"></div>
                    <div class="cnt-hours"></div>
                    <div class="note"></div>
                 </div>
                 <div class="btn-delete"><div class="font-icon icon-cross"></div></div>
             </div>`
         );
 

        elSelected.setData('item', item);
        
        elSelected.querySelector('.name').innerText = this.set.itemTextValue(item.data);
        elSelected.querySelector('.cnt-hours').innerText = item.info.value;
        elSelected.querySelector('.note').innerText = (item.info.note ? ' (' + item.info.note + ')' : '');

        elSelected.querySelector('.justified').checked = !!item.info.justified;

        elSelected.querySelector('.justified').onclick = (event) => {
            event.stopPropagation();
            elSelected.getData('item').info.justified = event.target.checked;            
        }        

        elSelected.querySelector('.left').onclick = (event) => {
            event.stopPropagation();
        }

        elSelected.querySelector('.middle').onclick = (event) => {
            event.stopPropagation();

            let maxHours = Math.max(this.classRegisterData.hour.to - (this.classRegisterData.hour.from -1), this.classRegisterData.hourSpan);
            let item = elSelected.getData('item');

            //console.log(item.info);

            new ModalEditAbsence(
                `Fehlstunden von ${item.data.lastName}, ${item.data.firstName}`,
                maxHours,
                item.info.value,
                item.info.note ? item.info.note : '',
                (value, note) => {
                    item.info.note = note;
                    item.info.value = value;
                    this.setupItem(elSelected, item);
                    this.set.onChange(this.getSelectedItems());
                }
            );
        }

        this.setupItem(elSelected, item);
  
        return elSelected;
  
    }

    setupItem(element, item) {
        element.querySelector('.note').innerHTML = item.info.note && item.info.note.length ? ` (${item.info.note})` : '';
        element.querySelector('.cnt-hours').innerHTML = item.info.value;

        //let maxHours = this.classRegisterData.hour.to - (this.classRegisterData.hour.from -1);
        element.querySelector('.cnt-hours').style.display = this.classRegisterData.hourSpan === item.info.value ? 'none' : 'flex';

    }


  }